webpackJsonp([252725346515905],{

/***/ 469:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"abstract":"This paper describes the motivation, design, and implementation of new features in EarSketch that enable the collaborative creation of algorithmic music. EarSketch is a web-based Digital Audio Workstation (DAW), designed primarily for educational contexts, in which users author Python or JavaScript code to programmatically create music within a multi-track paradigm. In this paper, we describe these new collaborative features in EarSketch and discuss their potential for use in both educational and music performance contexts.","authors":[{"name":"Avneesh Sarwate"},{"name":"Takahiko Tsuchiya"},{"name":"Jason Freeman"}],"slug":"collaborative-coding-with-music-two-case-studies-with-earsketch","title":"Collaborative Coding with Music: Two Case Studies with EarSketch","type":"paper"}}

/***/ })

});


// WEBPACK FOOTER //
// path---presentations-collaborative-coding-with-music-two-case-studies-with-earsketch-02ca76aae45c05b864b1.js